function initializeSlick() {
    var windowWidth = $(window).width();

    if ($('.slick-modelos-laufenn').hasClass('slick-initialized')) {
        $('.slick-modelos-laufenn').slick('unslick');
    }

    if (windowWidth < 768) {
        $('.slick-modelos-laufenn').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            variableWidth: true,
            swipeToSlide: true
        });
    } else if (windowWidth >= 768 && windowWidth <= 992) {
        $('.slick-modelos-laufenn').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            variableWidth: true,
            swipeToSlide: true
        });
    }else if (windowWidth >= 992 && windowWidth <= 1200) {
        $('.slick-modelos-laufenn').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            variableWidth: true,
            swipeToSlide: true
        });
    } else if (windowWidth >= 1200 && windowWidth < 1440) {
        $('.slick-modelos-laufenn').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            variableWidth: true,
            swipeToSlide: true
        });
    } else if (windowWidth >= 1424) {
        $('.slick-modelos-laufenn').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            // variableWidth: true, poner si número distinto a slidesToShow + porcentaje en sass o ancho fijo
            swipeToSlide: true
        });
    }
}

$(document).ready(function() {


    function scrollToItem() {
        var targetId = window.location.hash;
        if (targetId) {
            var target = $(targetId);
            if (target.length) {
                var targetOffset = target.offset().top;
                var headerHeight = $('header').outerHeight();
                
                if (window.location.href.includes('#entra-en-la-red-neumago')) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: targetOffset - headerHeight + 1
                    }, 300);
                }
            
                else {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: targetOffset - headerHeight
                    }, 300);
                }

                $('a[href^="/#"]').removeClass('active'); 
                $('a[href="/' + targetId + '"]').addClass('active');
            }
        }
    }

    if (window.location.hash) {
        scrollToItem();
    } else if (window.location.pathname === '/') {
        $('.js-inicio').addClass('active');
    }

    initializeSlick();

    $(window).on('resize', function() {
        initializeSlick();
    });

 
});


function toggleMenu () {
    $('.menu-mobile__items').toggleClass('opened');
    $('.menu-mobile__button').toggleClass('opened');
    $('header').toggleClass('header--darkheader2');
    $('body').toggleClass('overflow-none');
    $('html').toggleClass('overflow-none');
}

$('.menu-mobile__button').click(function() {
    toggleMenu ();
});

$('a[href^="/#"]').click(function(event) {

    var targetID = $(this).attr('href').replace('/', '');
    var targetOffset = $(targetID).offset().top;
    var headerHeight = $('header').outerHeight();
    
    if ($(this).attr('href') === '/#entra-en-la-red-neumago') {
        $([document.documentElement, document.body]).animate({
            scrollTop: targetOffset - headerHeight + 1
        }, 300);
    }

    else {
        $([document.documentElement, document.body]).animate({
            scrollTop: targetOffset - headerHeight
        }, 300);
    }

    $('a[href^="/#"]').removeClass('active');
    $(this).addClass('active');

    if ($('.menu-mobile__items').hasClass('opened')) {
        toggleMenu ();
    }

    $('.menu-mobile__items').removeClass('opened');
});

$('.index').click(function(event) {

    var targetID = $(this).attr('href');
    var targetOffset = $(targetID).offset().top;
    var headerHeight = $('header').outerHeight();
    
    $([document.documentElement, document.body]).animate({
        scrollTop: targetOffset - headerHeight
    }, 300);

});
    

$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    var sections = $("section"); 
    var navLinks = $('.menu-item a'); // Enlaces en el menú de navegación

    if (scroll >= 100) {
        $("header").addClass("header--darkheader");
    } else {
        $("header").removeClass("header--darkheader");
    }

    sections.each(function() {
        var section = $(this);
        var sectionTop = section.offset().top - ($('header').outerHeight() + 20);
        var sectionBottom = sectionTop + section.outerHeight();
        
        if (scroll >= sectionTop && scroll < sectionBottom) {
            var sectionId = section.attr("id");
            navLinks.removeClass("active");
            $('a[href="/#' + sectionId + '"]').addClass("active");
        }
    });
});

$('.js-see-video').click(function() {
    $('.js-popup').removeClass('hide');
    $('body').addClass('overflow-none');
    $('html').addClass('overflow-none');
});

$('.js-close-popup').click(function() {
    $('.js-popup').addClass('hide');
    $('body').removeClass('overflow-none');
    $('html').removeClass('overflow-none');
});


// Workshops
var SHOW_MORE_WORKSHOPS;
$('.js-show-more-workshops').click(function() {
    const hiddenWorkshops = $('.taller-hidden')

    if (hiddenWorkshops.length === 0) {
        return;
    }

    if (SHOW_MORE_WORKSHOPS !== undefined) {
        hiddenWorkshops.slice(0, SHOW_MORE_WORKSHOPS).removeClass('taller-hidden');
    } else {
        console.warn("Showing all workshops because there was an error retrieving the backend constant")
        hiddenWorkshops.removeClass('taller-hidden');
    }

    const showMoreButton = $('#show-more-workshops');

    if ($('.taller-hidden').length === 0) {
        showMoreButton.hide();
    }
})

$(document).ready(function() {
    $.ajax({
        url: 'get-constant/workshops.show_more',
        type: 'GET',
        dataType: 'text',
        success: function(data) {
            if (data == '') {
                console.error("Constant not found");
                return;
            } 
            SHOW_MORE_WORKSHOPS = data;
        },
        error: function(xhr, status, error) {
            console.error('Request failed. Status:', status, 'Error:', error);
        }
    });
})